// Hooks react-idle-timer to drive the IdleModal and auto-logout, replacing
// the Angular @ng-idle/core + @ng-idle/keepalive setup in AppComponent.
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth0 } from '@auth0/auth0-react';
import { appConfig } from '@/api/appConfig';
import { IdleModal } from './IdleModal';

const IDLE_MS = appConfig.timeoutInactivity * 1000;
const PROMPT_MS = appConfig.remainingTime * 1000;

export function IdleWatcher() {
  const { isAuthenticated, logout } = useAuth0();
  const [open, setOpen] = useState(false);
  const [remaining, setRemaining] = useState<number>(appConfig.remainingTime);

  const { activate, getRemainingTime } = useIdleTimer({
    timeout: IDLE_MS,
    promptBeforeIdle: PROMPT_MS,
    crossTab: true,
    syncTimers: 200,
    disabled: !isAuthenticated,
    onPrompt: () => {
      setOpen(true);
      setRemaining(Math.ceil(PROMPT_MS / 1000));
    },
    onIdle: () => {
      setOpen(false);
      logout({ logoutParams: { returnTo: window.location.origin } });
    },
    onActive: () => {
      setOpen(false);
    },
    onAction: () => {
      if (open) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    },
  });

  if (!isAuthenticated) return null;

  return (
    <IdleModal
      open={open}
      remainingSeconds={remaining}
      onStay={() => {
        setOpen(false);
        activate();
      }}
      onLogout={() => {
        setOpen(false);
        logout({ logoutParams: { returnTo: window.location.origin } });
      }}
    />
  );
}
